export enum ReloadKinds {
  /** 患者情報の再読込 対象外 */
  None = 1,
  /** 患者情報の再読込 自動設定 */
  Auto = 2,
  /** 患者情報の再読込 任意設定 */
  Manual = 3,
  /** 患者情報の再読込 任意設定(設定により自動設定) */
  ManualAuto = 4,
}
